<fieldset>
  <legend class="block text-sm font-medium text-primary">Notify me about replies via</legend>
  <div class="mt-3 space-y-3 rounded-lg border border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-900 px-4 py-3">
    @if (hasMobile()) {
      <label class="flex items-start gap-3 text-sm text-secondary">
        <input
          type="checkbox"
          class="mt-0.5 rounded border-gray-300"
          [ngModel]="prefs().sms"
          (ngModelChange)="onSmsChange($event)"
        />
        <span>
          <span class="font-medium text-primary">Text message (SMS)</span>
          <span class="mt-0.5 block text-xs text-secondary">We'll text {{ currentMobile() }}.</span>
        </span>
      </label>

      <label class="flex items-start gap-3 text-sm text-secondary">
        <input
          type="checkbox"
          class="mt-0.5 rounded border-gray-300"
          [ngModel]="prefs().whatsapp"
          (ngModelChange)="onWhatsappChange($event)"
        />
        <span>
          <span class="font-medium text-primary">WhatsApp</span>
          <span class="mt-0.5 block text-xs text-secondary">We'll message {{ currentMobile() }} on WhatsApp.</span>
        </span>
      </label>
    } @else {
      <div class="rounded-lg border border-amber-200 bg-amber-50 dark:bg-amber-950/40 dark:border-amber-800 px-3 py-3">
        <p class="text-sm font-medium text-amber-900 dark:text-amber-200">SMS and WhatsApp aren't connected</p>
        <p class="mt-1 text-xs text-amber-800 dark:text-amber-300">
          There's no mobile number on your account yet, so we can't send text or WhatsApp alerts.
        </p>

        @if (allowMobileUpdate()) {
          <div class="mt-3 space-y-2">
            <label for="supportMobile" class="block text-xs font-medium text-primary">Add a mobile number</label>
            <div class="flex flex-wrap gap-2">
              <input
                id="supportMobile"
                type="tel"
                class="min-w-[200px] flex-1 rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 px-3 py-2 text-sm"
                [ngModel]="mobileInput()"
                (ngModelChange)="mobileInput.set($event)"
                placeholder="e.g. 07887706033"
              />
              <button
                type="button"
                class="btn-basic-sm btn-primary"
                [disabled]="savingMobile()"
                (click)="saveMobile()"
              >
                {{ savingMobile() ? 'Saving...' : 'Save number' }}
              </button>
            </div>
            @if (mobileError()) {
              <p class="text-xs text-rose-600">{{ mobileError() }}</p>
            }
            @if (mobileSuccess()) {
              <p class="text-xs font-medium text-emerald-700">{{ mobileSuccess() }}</p>
            }
          </div>
        } @else {
          <p class="mt-2 text-xs text-amber-800 dark:text-amber-300">Log in to your SHOUT account to add a mobile number.</p>
        }
      </div>
    }

    <label class="flex items-start gap-3 text-sm text-secondary">
      <input
        type="checkbox"
        class="mt-0.5 rounded border-gray-300"
        [ngModel]="prefs().email"
        (ngModelChange)="onEmailChange($event)"
      />
      <span>
        <span class="font-medium text-primary">Email</span>
        @if (hasEmail()) {
          <span class="mt-0.5 block text-xs text-secondary">We'll email {{ currentEmail() }}</span>
        } @else {
          <span class="mt-0.5 block text-xs text-secondary">We'll email the address on your account.</span>
        }
      </span>
    </label>

    @if (hasPushDevice()) {
      <label class="flex items-start gap-3 text-sm text-secondary">
        <input
          type="checkbox"
          class="mt-0.5 rounded border-gray-300"
          [ngModel]="prefs().push"
          (ngModelChange)="onPushChange($event)"
        />
        <span>
          <span class="font-medium text-primary">Push notification</span>
          <span class="mt-0.5 block text-xs text-secondary">We'll notify you in the SHOUT app.</span>
        </span>
      </label>
    }
  </div>
</fieldset>
